import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-502b1a6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mxa-pos-msg" }, null, -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "mxa-dsec-msg",
  "data-test": "desc_msg"
}

import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@/store'
import BaseInput from '@/components/common/input/BaseInput.vue'
import ErrorMessage from '@/components/common/screen/ErrorMessage.vue'
import { useDownloadSearch, search, isFail } from '@/model/components/users/userDownloadSearch'
import { useDownloadDetail } from '@/model/components/users/userDownloadDetail'
import * as log from '@/model/util/log/Logger'


export default /*#__PURE__*/_defineComponent({
  __name: 'DownLoadSearch',
  props: {
  // ダウンロードキー
  searchkey: {
    type: String,
    default: '',
  },
  // 検索有無
  isSearch: {
    type: Boolean,
    default: true,
  },
  // 失敗メッセージ
  failmsg: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props

log.trace(`DownloadSearch setup start.`)

// プロパティ定義


// 状態
const store = useStore()
const router = useRouter()

const { state, errorState, isError, errorFailState } = useDownloadSearch(props, store)
const { isDetail } = useDownloadDetail(store)

// onMountedの登録
onMounted(() => {
  log.trace('DownLoadSearch onMounted start.')
  // 検索キーが設定されている場合は、検索処理を実施
  log.debug(`DownLoadSearch onMounted search. key:${props.searchkey}`)
  if (props.searchkey && props.isSearch) {
    state.key = props.searchkey
    search(state, store, router, errorState, errorFailState, true)
  }
  log.trace('DownLoadSearch onMounted end.')
})

// ダウンロードキー検索ボタン押下
const onSearch = () => {
  log.trace(`DownLoadSearch onSearch start.`)
  search(state, store, router, errorState, errorFailState, false)
  log.trace(`DownLoadSearch onSearch start.`)
}

log.trace(`DownloadSearch setup end.`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("form", {
        action: "",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
        novalidate: ""
      }, [
        _createVNode(BaseInput, {
          type: "text",
          inputmode: "search",
          placeholder: _ctx.$t('body.main.download.keyinput.placeholder'),
          maxlength: 20,
          modelValue: _unref(state).key,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).key) = $event)),
          clearButton: true,
          searchButton: true,
          "search-button-loading": _unref(state).loading,
          "search-button-is-disabled": _unref(state).loading,
          stylesParent: "mxa-download-input",
          "init-focus": true,
          onSearchClick: onSearch,
          "data-test": "downloadkey"
        }, null, 8, ["placeholder", "modelValue", "search-button-loading", "search-button-is-disabled"])
      ], 32)
    ]),
    _hoisted_1,
    (!_unref(isDetail))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_unref(isFail)(props))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(ErrorMessage, {
                  error: _unref(errorFailState),
                  "data-test": "error_fail"
                }, null, 8, ["error"])
              ]))
            : _createCommentVNode("", true),
          (!_unref(isError))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('body.main.download.description.message')), 1))
            : _createCommentVNode("", true),
          _createVNode(ErrorMessage, {
            error: _unref(errorState),
            "data-test": "error"
          }, null, 8, ["error"])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})